import { Pipe, PipeTransform } from '@angular/core';
import { findIndex as _findIndex, isUndefined as _isUndefined} from 'lodash-es';

@Pipe({
  name: 'showTableCategory',
  pure: true
})
export class ShowTableCategoryPipe implements PipeTransform {

  transform(category: any, alreadyShowCategories: Set<any>, index, row, groupedTables) {
      const isTitlePresent = alreadyShowCategories.has(category);
      const indexOf = _findIndex(groupedTables[category], {name: row.name});
      index = !_isUndefined(index) ? index : indexOf;
      alreadyShowCategories.add(category);
      if (index === 0 && !isTitlePresent) {
        return category;
      } else if (isTitlePresent) {
        return '';
      } else {
        return category;
      }
  }

}
